export const BINGO_ROW_KEY = 'bingo_r';
export const BINGO_COL_KEY = 'bingo_c';

/**
 * Merge bingo cell selection into a route query (preserves `t` and other params).
 */
export function mergeBingoCellQuery(baseQuery, row, col) {
  return {
    ...(baseQuery || {}),
    [BINGO_ROW_KEY]: String(row),
    [BINGO_COL_KEY]: String(col)
  };
}

/**
 * Parse [row, col] from route query, or null if missing/invalid.
 */
export function parseBingoCellFromQuery(query) {
  if (!query) return null;
  const r = query[BINGO_ROW_KEY];
  const c = query[BINGO_COL_KEY];
  if (r == null || c == null || r === '' || c === '') return null;
  const row = parseInt(r, 10);
  const col = parseInt(c, 10);
  if (!Number.isFinite(row) || !Number.isFinite(col)) return null;
  if (row < 0 || col < 0) return null;
  return [row, col];
}

/**
 * Remove bingo cell keys from a query object (returns a new object).
 */
export function stripBingoCellFromQuery(query) {
  if (!query || typeof query !== 'object') return {};
  const { [BINGO_ROW_KEY]: _r, [BINGO_COL_KEY]: _c, ...rest } = query;
  return rest;
}
